import { type HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/cn';

export interface ScrollAreaProps extends HTMLAttributes<HTMLDivElement> {
  orientation?: 'vertical' | 'horizontal' | 'both';
}

const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ className, children, orientation = 'vertical', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'relative overflow-hidden',
        orientation === 'vertical' && 'overflow-y-auto overflow-x-hidden',
        orientation === 'horizontal' && 'overflow-x-auto overflow-y-hidden',
        orientation === 'both' && 'overflow-auto',
        className
      )}
      {...props}
    >
      {children}
      {/* Scrollbar styling matches globals.css (surface-800 track, accent-500 thumb) */}
    </div>
  )
);
ScrollArea.displayName = 'ScrollArea';

export { ScrollArea };
